const styles = {
	dialogPaper: {
		width: 300,
		minHeight: 200,
		borderRadius: '16px',
		border: '1px solid #8B8B8B',
		background: '#FFF',
		boxShadow: '0px 2px 16px 0px rgba(0, 0, 0, 0.08)',
	},
	contentBox: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
	},
	dialogContent: {
		padding: '0px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	text: {
		color: '#153c3c',
		textAlign: 'center',
	},
	actions: {
		justifyContent: 'center',
		pb: 3,
	},
	okButton: {
		color: '#333',
		backgroundColor: '#C5C5C5',
		'&:hover': {
			backgroundColor: '#d0d0d0',
		},
	},
};

export default styles;
